import {generateSlider} from '../exports/generateSwiper';
import {ongsCharacteristicsSettings} from '../exports/swiperSettings';

export default {
  init() {
    /*
     * SELECTORS
     */
      let  instantGamesSwiper = '.mobile-instant-swiper'
    /*
     * EVENTS
     */
    /*
    * ACTIONS
    */
      generateSlider(instantGamesSwiper, ongsCharacteristicsSettings);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/instantGames.js